export default __webpack_public_path__ + "static/media/paste.1e3aee31.svg";